import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { ScrollView, tokens } from '@fhs/ui';
import { useFeatureNavigation } from '@fhs-legacy/frontend/src/hooks/use-feature-navigation';
import { useLocale } from '@fhs-legacy/frontend/src/state/intl';

import { type NavigationEntry, flattenNavigationEntries, policyLinks } from './more-navigation';
import { MoreLinkCard } from './shared';

export function OtherTermsScreen() {
  const { region } = useLocale();
  const { featureAboutMenuEntriesMobile } = useFeatureNavigation();
  const cmsLinks = useMemo(
    () =>
      flattenNavigationEntries(
        (featureAboutMenuEntriesMobile?.pages ?? []) as readonly NavigationEntry[]
      ),
    [featureAboutMenuEntriesMobile]
  );

  return (
    <View style={styles.screen}>
      <ScrollView contentContainerStyle={styles.content}>
        <MoreLinkCard links={policyLinks(cmsLinks, region)} />
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: { flex: 1, backgroundColor: tokens.colors.$white },
  content: {
    alignSelf: 'center',
    maxWidth: 600,
    paddingBottom: 24,
    paddingHorizontal: 16,
    paddingTop: 24,
    width: '100%',
  },
});
